module.exports = __webpack_public_path__ + "img/etherscan.90a89bb2.png";